import { storeToRefs } from 'pinia';
import mainStore from '@/stores/main-store';

const useMainStore = () => {
    const {
        accessToken,
        oid,
        claims,
        attributeStoreData,
        userId,
        username,
        loginType,
        roles,
        tokenShouldBeRefreshed,
        partnerParcelNumberTypes
    } = storeToRefs(mainStore());

    return {
        accessToken,
        oid,
        claims,
        attributeStoreData,
        username,
        userId,
        loginType,
        roles,
        tokenShouldBeRefreshed,
        partnerParcelNumberTypes
    };
};

export default useMainStore;
